import React, { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux';
import { getAllBlogs } from '../redux/actions/blogs';
import { Loader ,BlogsCard} from '../components/utils';
import { useLocation ,Link } from 'react-router-dom'; 
import {Pagination} from "../components/utils"
import {Button,Section,Fotter,Header} from "../components/layout"
import { useStateContext } from '../context/ContextProvider';
import { media } from '../server';
import { renderText } from '../components/hooks/TextVeiw';
function AllBlogs() {
    const {t} =useTranslation()
    const dispatch = useDispatch();
    const { isLoading, AllBlogs, pagination } = useSelector((state) => state.Blogs);
const totalPages =pagination?.totalPages
const {currentDir} = useStateContext()
    // إضافة state لإدارة الصفحة الحالية وعدد العناصر في الصفحة
    const [page, setPage] = useState(0);
    const [limit, setLimit] = useState(10); // يمكنك تغيير القيمة الافتراضية هنا
    const location = useLocation();
    const { category } = location.state
    const categoryId=category._id
    useEffect(() => {
      // استدعاء getAllblogss مع page و limit الحاليين
      dispatch(getAllBlogs(page, limit ,categoryId));
    }, [page, limit,categoryId ,dispatch]);
 
  return (
    <>
    <Header active={4} />
    <div className="w-full overflow-hidden h-[400px] lg:h-[600px] relative "><img src={`${media}${category.Image}`} className=" w-full h-full object-cover"/>
    <div className=" absolute p-5 max-w-35 bottom-5">  <h2 className="h2 text-color-1 dark:text-tcolor-1 mb-4 md:mb-8">  {currentDir === "ltr" ?category.titleEn :category.titleAr}</h2>
    <p className="body-1 text-tcolor-2 text-wrap">
       {currentDir === "ltr" ?renderText(category.textEn,"body-1 text-tcolor-2 text-wrap") :renderText(category.textAr,"body-1 !text-tcolor-2 text-wrap")}
</p>
    </div>
  
      </div>
    {isLoading ? (
   <Loader />
    ) : (  
  
    <Section>
    {/* For mobile view: Title and description above the image */}
    <div className="flex pt-3 flex-col lg:gap-10 gap-5 ">
    <div className="">
              <ul className="flex gap-3 flex-row">
                <Link to={"/BlogsCategory"}
                      onClick={() => {
                        window.scrollTo(0, 0); 
                      }}
                >   <li className="font-kufi lg:text-2xl text-md  leading-normal dark:text-tcolor-2 text-tcolor-4">
                  {t("Blogs")}
                </li></Link>
              
                <span className="font-kufi lg:text-2xl text-md  leading-normal dark:text-tcolor-2 text-tcolor-4">
                  /
                </span>
                <li className="font-kufi lg:text-2xl text-md text-wrap leading-normal dark:text-tcolor-1 text-color-1">
                {currentDir === "ltr" ? category.titleEn : category.titleAr}
                </li>
              </ul>{" "}
            </div>
      <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-8 sm:grid-cols-1">
              {AllBlogs?.map((blogs, index) => (
                <BlogsCard key={index} blogs={blogs} category={category}/>
              ))}
            </div>
            <Pagination
              currentPage={page}
              totalPages={totalPages}
              setPage={setPage}
            />
    </div>
    </Section>
    )}<Fotter/></>
  )
}

export default AllBlogs